// Created 2024-04-09 for RefreshToken https://www.bezkoder.com/vue-3-refresh-token/
import axios from 'axios';
const api = axios.create({
    baseURL: process.env.VUE_APP_ROOT_API,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});
export default api;
